export enum SegmentacionEnum {
  RETAIL = 1,
  MAYORISTA=2,
  SUPERMAYORISTA=3
}
